'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "children", "role"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIBreadcrumbs from '../nav/UIBreadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
class UIBackButton extends Component {
  constructor(...args) {
    super(...args);
    this.getClassName = ({
      className
    }) => {
      return classNames('private-back-button', className);
    };
  }
  render() {
    const _this$props = this.props,
      {
        className,
        children,
        role
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIBreadcrumbs, Object.assign({}, rest, {
      className: this.getClassName({
        className
      }),
      role: role,
      children: children
    }));
  }
}
UIBackButton.displayName = 'UIBackButton';
UIBackButton.propTypes = {
  children: PropTypes.element.isRequired,
  role: PropTypes.string
};
UIBackButton.defaultProps = {
  role: 'navigation'
};
export default UIBackButton;